module.exports = __webpack_public_path__ + "img/iron-man_marvel_feature.36e7c787.jpg";